import {Badge, Breadcrumb, Col, Container, Row} from "react-bootstrap";
import styles from "./usermanagement.module.css";
import {EditForm} from "./forms/EditForm";
import {NewForm} from "./forms/NewForm";
import {useTranslation} from "react-i18next";
import {useLocation, useNavigate, useNavigation} from "react-router";
import {MultiEditForm} from "./forms/MultiEditForm";

export const MultiEdit = (props) => {

    const {t} = useTranslation();
    const navigate = useNavigate()
    const {state} = useLocation();

    const handleHome = () => {
        navigate("/")
    }

    return(<Container fluid={true}>
        <Row className={"justify-content-end"}>
            <Col className={"d-flex justify-content-start"}>
                <Breadcrumb className={"mt-3"}>
                    <Breadcrumb.Item onClick={handleHome}>{t('breadcrumbs.home')}</Breadcrumb.Item>
                    <Breadcrumb.Item active>
                        {t('breadcrumbs.multiedit')}
                    </Breadcrumb.Item>
                </Breadcrumb>
            </Col>
        </Row>
        <MultiEditForm users={state.data}/>
    </Container>)

}